import { Row } from 'antd';
import styled from 'styled-components';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';
import CustomDatePicker from '~src/shared/form/inputs/CustomDatePicker';
import CustomFormInput from '~src/shared/reactFinalForm/FormInput';
import { InputContainer } from '~src/shared/sidebar/styles/search.sc';

export const Container = styled.div``;

export const CyclesSection = styled.div`
  margin: 0.5rem 0rem;
  // height: 300px;
  // overflow: scroll;
`;

export const CyclesLabel = styled.h4`
  margin-bottom: 1rem;
`;

export const CustomDatePickerStyled = styled(CustomDatePicker)`
  width: 100%;
`;

export const CyclesContainer = styled(Row).attrs({ gutter: 16 })`
  align-items: center;
`;

export const ActionButton = styled.div<{ $disabled?: boolean }>`
  cursor: pointer;
  color: ${({ theme }) => theme.baseBlue.a6};
  opacity: ${(p) => (p.$disabled ? 0.5 : 1)};
  pointer-events: ${(p) => (p.$disabled ? 'none' : 'unset')};
  &:hover {
    opacity: ${(p) => (p.$disabled ? 0.5 : 0.6)};
  }
  margin: 0rem 0.2rem;
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  margin-bottom: 1rem;
`;

export const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
`;

export const ToggleInputContainer = styled.div`
  display: flex;
  margin: 0.6rem 0rem;
  justify-content: space-between;
`;

export const StatusContainer = styled.div`
  display: flex;
  width: 15%;
  margin-bottom: 1rem;
`;

export const FormInput = styled(CustomFormInput)`
  margin: 0;
`;

export const DaysContainer = styled(InputContainer)`
  margin: 1rem 2rem;
`;

export const RightContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`;

export const SecondaryButtonStyled = styled(SecondaryButton) <{ $disabled?: boolean }>`
  opacity: ${(p) => (p.$disabled ? 0.7 : 1)};
  pointer-events: ${(p) => (p.$disabled ? 'none' : 'unset')};
`
